import ApiService from "@/core/services/api.service";

const END_POINT = "/report";

const getJobReport = params => ApiService.download(`${END_POINT}/jobs`, params);

export { getJobReport };
